import styled from 'styled-components';
import {
  Dropdown as dropdown,
  DropdownToggle as dropdownToggle,
  DropdownMenu as dropdownMenu,
  DropdownItem as dropdownItem,
  UncontrolledDropdown as uncontrolledDropdown,
  ButtonDropdown as buttonDropdown,
} from 'reactstrap';

export const Dropdown = styled(dropdown)``;

export const UncontrolledDropdown = styled(uncontrolledDropdown)``;

export const ButtonDropdown = styled(buttonDropdown)``;

export const DropdownToggle = styled(dropdownToggle)`
  &.dropdown-toggle,
  &.nav-link {
    &:focus {
      box-shadow: none;
      outline: none;
    }
  }
`;

export const DropdownMenu = styled(dropdownMenu)`
  background: ${({ theme }) => theme.colors.semantic.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  box-shadow: ${({ theme }) => theme.colors.semantic.shadow.lg};
`;

export const DropdownItem = styled(dropdownItem)`
  color: ${({ theme }) => theme.colors.semantic.text.primary};

  &:hover,
  &:focus,
  &.active,
  &:active {
    background: ${({ theme }) => theme.colors.semantic.surface.muted};
    color: ${({ theme }) => theme.colors.semantic.text.primary};
  }
`;
